  import React, { useEffect, useState } from 'react';
  import axios from 'axios';
  import './UsuarioConfig.css';

  const MODEL_OPTIONS = [
    { value: 'gpt-3.5-turbo', label: 'GPT-3.5 Turbo' },
    { value: 'gpt-4-turbo',  label: 'GPT-4 Turbo' },
    { value: 'gpt-4',        label: 'GPT-4 (clássico)' },
    { value: 'gpt-5',        label: 'GPT-5' }, // remova se não for usar agora
  ];

  function UsuarioConfig() {
    const [usuarios, setUsuarios] = useState([]);
    const [carregando, setCarregando] = useState(false);

    const API = 'https://welaunchyou.com.br/crm-wly/usuario_config.php';

    const carregarUsuarios = async () => {
      setCarregando(true);
      try {
        const res = await axios.get(API, { withCredentials: true });
        if (res.data?.success) setUsuarios(res.data.usuarios);
      } catch (err) {
        console.error('Erro ao carregar usuários:', err);
      } finally {
        setCarregando(false);
      }
    };

    // POST enxuto: envia só os campos aceitos pelo PHP
    const salvarUsuario = async (payload) => {
      return axios.post(
        API,
        payload,
        { withCredentials: true, headers: { 'Content-Type': 'application/json' } }
      );
    };

    // Atualização genérica de qualquer campo
    const atualizarUsuario = async (id, campo, valor) => {
    try {
      const u = usuarios.find(x => x.id === id);
      if (!u) return;

      // normaliza o modelo atual do usuário
      const modeloAtual = (u.modelo_openai || '').toString().trim() || 'gpt-3.5-turbo';

      const payload = {
        id,
        ia_ativa:       campo === 'ia_ativa'       ? (valor ? 1 : 0) : (u.ia_ativa ?? 0),
        whatsapp_ativo: campo === 'whatsapp_ativo' ? (valor ? 1 : 0) : (u.whatsapp_ativo ?? 0),
        modelo_openai:  campo === 'modelo_openai'  ? valor : modeloAtual,
      };

      const res = await axios.post(
        'https://welaunchyou.com.br/crm-wly/usuario_config.php',
        payload,
        { withCredentials: true, headers: { 'Content-Type': 'application/json' } }
      );

      if (!res.data?.success) throw new Error(res.data?.message || 'Falha ao salvar');
      // atualiza local otimistamente
      setUsuarios(prev => prev.map(x => x.id === id ? { ...x, ...payload } : x));
    } catch (err) {
      const msg = err?.response?.data?.message || err?.message || 'Erro desconhecido';
      console.error('Atualização falhou:', err?.response || err);
      alert('Erro ao atualizar usuário: ' + msg);
    }
  };


    useEffect(() => { carregarUsuarios(); }, []);

    // Handlers para impedir submit/propagação que causam refresh
    const preventAll = (e) => { e.preventDefault(); e.stopPropagation(); };
    const stopOnly   = (e) => { e.stopPropagation(); };

    return (
      <div className="usuario-config-wrapper" onKeyDown={(e) => {
        // evita que Enter dispare submit em algum form ancestral
        if (e.key === 'Enter') e.preventDefault();
      }}>
        <h1 style={{ borderBottom: "none" }}>Controle de Funções por Usuário</h1>

        {/* se existir algum <form> pai na página, este form local já bloqueia submit */}
        <form onSubmit={(e) => e.preventDefault()} noValidate>
          {carregando ? (
            <p>Carregando...</p>
          ) : (
            <table className="usuario-config-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Usuário</th>
                  <th>Email</th>
                  <th>Modelo GPT</th>
                  <th>Agente IA</th>
                  <th>WhatsApp</th>
                </tr>
              </thead>
              <tbody>
                {usuarios.map(user => (
                  <tr key={user.id}>
                    <td>{user.id}</td>
                    <td>{user.nome}</td>
                    <td>{user.email}</td>
                    <td>
                      <span>{user.modelo_openai || 'gpt-4.1'}</span>
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        className="usuario-config-checkbox"
                        checked={user.ia_ativa === 1}
                        onChange={(e) => {
                          preventAll(e); // impede qualquer submit/refresh
                          atualizarUsuario(user.id, 'ia_ativa', e.target.checked);
                        }}
                        onClick={stopOnly}
                      />
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        className="usuario-config-checkbox"
                        checked={user.whatsapp_ativo === 1}
                        onChange={(e) => {
                          preventAll(e);
                          atualizarUsuario(user.id, 'whatsapp_ativo', e.target.checked);
                        }}
                        onClick={stopOnly}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </form>
      </div>
    );
  }

  export default UsuarioConfig;
